import { render } from "./PaymentCardperiodDisp.vue?vue&type=template&id=d2685c0c&scoped=true"
import script from "./PaymentCardperiodDisp.vue?vue&type=script&lang=js"
export * from "./PaymentCardperiodDisp.vue?vue&type=script&lang=js"

import "./PaymentCardperiodDisp.vue?vue&type=style&index=0&id=d2685c0c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-d2685c0c"

export default script